import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatInputModule } from '@angular/material/input';
import { MaskDirective } from './mask.directive';
import { InvalidControlScrollDirective } from './invalid-control-scroll.directive';

const directives = [MaskDirective, InvalidControlScrollDirective];

@NgModule({
	imports: [CommonModule, MatInputModule],
	declarations: directives,
	exports: directives
})
export class SharedDirectivesModule {}
